import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialogRef } from '@angular/material/dialog';
import { DocumentService } from '../../../service/document.service';
import { WorksiteService } from '../../../service/worksite.service';
import { LoggerService } from '../../../service/logger.service';
import { SwalService } from '../../../service/swal.service';
import Swal from 'sweetalert2';
import { lastValueFrom } from 'rxjs';
import * as chalk from 'chalk';

@Component({
  selector: 'app-add-immages',
  templateUrl: './add-immages.component.html',
  styleUrls: ['../../../../theme/modal.scss']
})

export class AddImmagesComponent implements OnInit, OnDestroy {  

  @ViewChild(MatSort, { static: true }) sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  public titleFile = null;

  x = JSON.parse(localStorage.getItem('selected worksite') || '[]');
  idWorksite = JSON.parse(localStorage.getItem('selected worksite')!).cantieri_key

  form!: FormGroup;
  titleImg: string = '';
  fileImg: File | null = null;  

  file: File | null = null;
  img: File | null = null;
  selectedTipo = this.x.tab_tipo_cantiere_desc;
  selectedTipoCod = this.x.cn_tipo_cantiere_cod;
  dataSource!: MatTableDataSource<any>;
  typesDocument: any;
  selectedTipoFoto: any;
  selectedTipoDocument: any;
  showTable = true;
  isAdmin = false;
  tab_tipo_cantiere_desc: any
  flag = false;
  images: any
  dataL = true

  constructor(
    private sDocument: DocumentService,
    private fb: UntypedFormBuilder,
    private sWorksite: WorksiteService,
    private swal: SwalService,
    private logger: LoggerService,
    public dialog: MatDialogRef<AddImmagesComponent>
  ) { }

  ngOnDestroy(): void {console.log('Component destroyed'); }


  async ngOnInit(): Promise<void> {
    this.form = this.fb.group({
      titleImg: [this.titleImg, Validators.required],
      fileImg: [null, [Validators.required]],
      cn_indirizzo: [this.x.cn_indirizzo /* { validators: [Validators.required] }*/],
      cn_cliente: [this.x.cn_cliente /*{ validators: [Validators.required] }*/],
      cn_note: [this.x.cn_note /*{ validators: [Validators.required] }*/],
    });
    const selectedWorksite = localStorage.getItem('selected worksite');
    const selectedidWorksite = localStorage.getItem('selected worksite');
    
    if (this.sWorksite && typeof this.sWorksite.getWorksite === 'function') {
      
      if (selectedWorksite) {
        try {
          const parsedWorksite = JSON.parse(selectedWorksite);  
          if (Array.isArray(parsedWorksite) && parsedWorksite.length > 0) {
            this.x = parsedWorksite[0]; 
            this.idWorksite = this.x?.cantieri_key; 
            this.tab_tipo_cantiere_desc = this.x.data.tab_tipo_cantiere_desc;
            this.images = this.x.pictures;
          } 
          else {
            console.error('Invalid worksite data in localStorage');
          }
        } catch (e) {
          console.error('Error parsing worksite data from localStorage:', e);
        }
      } 
      else {
        console.error('No worksite data found in localStorage');
      }
  
      if (this.idWorksite) {
        this.sWorksite.getWorksite(this.idWorksite)?.subscribe({
          next: (res) => {
            if (res?.data) {
              this.tab_tipo_cantiere_desc = res.data.tab_tipo_cantiere_desc;
              this.images = res.data.pictures;
            } 
            else {
              console.error('Invalid or empty data for worksite', res);
            }
            if(typeof this.logger.info === 'function'){
              this.logger.info('Server response for worksite data:', res);
            }
          },
          error: (error) => {
            console.error('Error fetching worksite data for idWorksite:', error);
          },
        });
      } 
      else {
        console.error('Invalid worksite ID:', this.idWorksite);
        this.logger.error('Invalid worksite ID:', this.idWorksite); // Facoltativo
        return; 
      }
  
      if (this.x?.cantieri_key) {
        this.sWorksite.getWorksite(this.x.cantieri_key)?.subscribe({
          next: (res) => {
            if (res?.data) {
              this.x = res.data;
            } 
            else {
              console.error('Error fetching worksite data for x.cantieri_key');
            }
          },
          error: (error) => {
            console.error('Error fetching worksite data for x.cantieri_key:', error);
          }
        });
      }
    } 
    else {
      console.error('sWorksite is not defined or does not have getWorksite method');
    }
  
    if (this.sDocument && this.sDocument.getTypesDocument) {
      try {
        const res = await lastValueFrom(this.sDocument.getTypesDocument()); // Usa lastValueFrom per ottenere il valore dall'Observable
        if (res?.data) {
          this.typesDocument = res.data; 
          if(typeof this.logger.info === 'function'){
            this.logger.info('Type of documents:', res.data);
          }
        } 
        else {
          console.error('Invalid or empty document types data:', res);
        }
      } catch (error) {
        console.error('Error fetching document types:', error);  // Gestione degli errori
      }
    } 
    else {
      console.error('Document service or getTypesDocument is not defined');
    }
  
    const userType = localStorage.getItem('ac_tipo_utente_cod');
    if (userType === '1') {
      this.isAdmin = true;
    }
  }  

  updateTypeFoto(type: any) {
    this.selectedTipoFoto = type;
  }

  onDocumentInput(files: FileList | null, title: string | null, type: number): void {
    if (files && files.length == 1) {
      this.file = files.item(0);
      if(typeof this.logger.info === 'function'){
        this.logger.info('File: ', this.file)
      }
      if (title == null) {
        this.swal.load_warning('In assenza del titolo verrà utilizzato il nome del file').then((result) => {
          if (result.value) {
            this.sDocument.uploadDocument(this.file!, this.file!.name, type);
          } 
          else if (result.dismiss === Swal.DismissReason.cancel) {
            this.swal.load_safe()
            window.location.reload();
            return;
          }
        });
      } 
      else {
        this.sDocument.uploadDocument(this.file!, title, type);
      }
    } 
    else {
      this.swal.load_one()
    }
  }

  onFileInput(files: FileList | null, title: string | null, type: number): void {
    if (!files || files.length === 0) {
      console.error('Please select a file.');
      return;
    }  
    const file = files.item(0);
    if (!file) {
      console.error('File is null.');
      return;
    }  
    const finalTitle = title || file.name;  
    this.sDocument.uploadFile(file, finalTitle, type);
  } 
  
  close() {
    this.dialog.close();
  }

} 
